import React, {useState, useEffect, useRef, Fragment} from 'react';
import parse from 'html-react-parser';
import { changePartNum, mrbgStore, removeGM, setActivePopups, setSettingsForm } from './mrbgRedux/index.js';
import mrbgS2S from '../../mrbgLib/mrbgS2S.js';
import {Mrbg} from '../../mrbgLib/Mrbg.js';
import {mrbgTools} from '../../mrbgLib/mrbgTools.js';
import MrbgCaptcha from './MrbgCaptcha.jsx';
import MrbgCheckBox from './MrbgCheckBox.jsx';
import MrbgHierarchicalList from './MrbgHierarchicalList.jsx';
import MrbgImgFile from './MrbgImgFile.jsx';
import MrbgNumberInput from './MrbgNumberInput.jsx';
import MrbgNormalInput from './MrbgNormalInput.jsx';
import MrbgPersianDateTime from './MrbgPersianDateTime.jsx';
import MrbgRadioInput from './MrbgRadioInput.jsx';
import MrbgSelect from './MrbgSelect.jsx';
import MrbgTable from './MrbgTable.jsx';
import MrbgTableInput from './MrbgTableInput.jsx';
import MrbgTextarea from './MrbgTextarea.jsx';
import MrbgTextEditor from './MrbgTextEditor.jsx';
import MrbgTimeLine from './MrbgTimeLine.jsx';
import MrbgCheckBoxList from './MrbgCheckBoxList.jsx';
import MrbgBilPayInfo from './MrbgBilPayInfo.jsx'

function MrbgFormsCreator({formID,title,origin,operation,inputs,filters,parts,tblID,columns,rowsCol,pencil,trash,view,unSortable,checkbox,think,multiRow,component,btn,msg,tableInputs,popupObj,hierarchicalList,hierarchicalListDir,hierarchicalListMaxDeep,keys__FF,op__FF,timeLine,blobResponse,formStyle}){

  const
    [fillFormKeys,setFillFormKeys] = useState( keys__FF?.createObjWithThisKeys('') ),
    [sortList,setSortList] = useState([]),
    [formsSettings,setFormsSettings] = useState( mrbgStore.getState().formsSettings[formID] ),
    [mainInput,setMainInput] = useState(mrbgStore.getState().mrbgVars?.mainSelect?.curLab||'fa'),
    [filterMode,setFilterMode] = useState(false);

  function submitHandler(e){
    e.preventDefault();

    const clicked = e.nativeEvent.submitter?.value;
    if( !origin || (!operation && clicked!=='flt') )
      return true;

    var
      curForm = document.getElementByDataID(formID),
      MD = new FormData(curForm),
      fileInputMultiple = curForm.querySelectorAll('input[type=file][multiple]');

    if( fileInputMultiple.length ){
      fileInputMultiple.forEach(fileInput=>{
        var fileName = fileInput.getAttribute('name');
        Object.keys(fileInput.files).forEach(k=>{
          MD.append(`${fileName}[]`, fileInput.files[k]);
        })
      })
    }

    if( hierarchicalList )
      MD.append('list',sortList);

    const mrbgTE = curForm.querySelector(`.${formStyle.mrbgTextEditor}`);
    if( mrbgTE ){
      MD.append( mrbgTE.getAttribute('name'), mrbgTE.innerHTML )

      const imgTags= mrbgTE.querySelectorAll('img[src^="data:image/"]');
      imgTags.forEach((img, index) => {
        const
          base64Data = img.src.split(',')[1],
          byteCharacters = atob(base64Data),
          byteArrays = [];

        for( let offset=0; offset<byteCharacters.length; offset+=512 ){
          const
            slice = byteCharacters.slice(offset, offset + 512),
            byteNumbers = new Array(slice.length);
          for( let i=0; i<slice.length; i++ )
            byteNumbers[i] = slice.charCodeAt(i);
          const byteArray = new Uint8Array(byteNumbers);
          byteArrays.push(byteArray);
        }

        let mimeType = 'image/jpeg';
        if( img.src.startsWith('data:image/png') )
          mimeType = 'image/png';
        else if( img.src.startsWith('data:image/pjpeg') )
          mimeType = 'image/pjpeg';
        else if( img.src.startsWith('data:image/webp') )
          mimeType = 'image/webp';
        else if( img.src.startsWith('data:image/gif') )
          mimeType = 'image/gif';
        else if( img.src.startsWith('data:image/bmp') )
          mimeType = 'image/bmp'

        const blob = new Blob(byteArrays, {type:mimeType});
        const file = new File([blob], `image${index}.${mimeType.split('/')[1]}`, {type:mimeType});

        MD.append('extraImg[]', file, `image${index}.jpg`);
      })
    }

    var op =
      clicked=='flt'?
        (formsSettings.op||clicked):
        (formsSettings.op||operation);

    mrbgS2S( formID, MD, op, origin, true, blobResponse );
  }
  function removeOldImg(img){
    var fs = JSON.parse(JSON.stringify(formsSettings));
    fs.disabled.splice(fs.disabled.indexOf(fs.imgInputName), 1);
    if( Array.isArray(fs.oldImg) ){
      var k = fs.oldImg.indexOf(img)
      fs.hideInp = {
        ...fs.hideInp,
        removedImg: (fs.hideInp.removedImg||[]).concat( [fs.oldImg[k]] )
      }
      fs.oldImg.splice(k,1);
      fs.hideInp[fs.imgInputName].splice(k,1);
      if( fs.hideInp[fs.imgInputName].length==0 )
        delete fs.hideInp[fs.imgInputName];
    }
    else{
      fs.hideInp = {
        ...fs.hideInp,
        removedImg: fs.oldImg
      }
      delete fs.hideInp[fs.imgInputName];
      fs.oldImg   = ''
    }
    mrbgStore.dispatch(setSettingsForm({[formID]:fs}))
  }

  useEffect(()=>{
    if( fillFormKeys && !Object.values(fillFormKeys).includes('') && !Mrbg.lockForm.includes(formID) ){
      Mrbg.lockForm.push( formID );
      var MD = new FormData();
      Object.keys(fillFormKeys).map(k=>{
        MD.append( k, fillFormKeys[k] )
      })
      mrbgS2S( formID, MD, op__FF||'gDt', origin );
    }
  },[fillFormKeys])
  useEffect(()=>{
    var
      msg       = document.getElementByDataID(formID)?.querySelector(`.${formStyle.msg}`),
      msgPos    = msg?.getBoundingClientRect(),
      scrolled  = false,
      removeMsg = e =>{
        if( e.target.closest(`input,textarea,label[for],.${formStyle.mrbgSelect},.${formStyle.mrbgPersianDate},.${formStyle.mrbgPersianDateTime},.${formStyle.mrbgTE}`) )
          mrbgStore.dispatch( removeGM(formID) );
      };
    if( !scrolled && msg && formsSettings.msgTxt && (Object.hasOwn(formsSettings.msgTxt,'__RM') || Object.hasOwn(formsSettings.msgTxt,'__GM')) ){
      window.scrollTo(0,window.scrollY+msgPos.top-Math.max(65,window.innerHeight-msgPos.height-15));
      scrolled = true;
      if( Object.hasOwn(formsSettings.msgTxt,'__GM') ){
        document.getElementByDataID(formID)?.addEventListener('click',removeMsg);
        document.removeEventListener('click',removeMsg)
      }
    }
  },[formsSettings?.msgTxt])
  useEffect(()=>{
    const unsubscribe = mrbgStore.subscribe(()=>{
      setFormsSettings(mrbgStore.getState().formsSettings[formID])
      setMainInput(mrbgStore.getState().mrbgVars?.mainSelect?.curLab||'fa')
    })
    return () =>unsubscribe();
  },[]);

  return(
    <form id={formStyle[formID]} data-id={formID} onSubmit={e=>submitHandler(e)}>
      {
        title?
          <FormTitle {...{formID,title,tblID,popupObj,formStyle}} />:
          ''
      }
      {
        inputs || parts?
          <div className={formStyle.fieldSetFrame}>
            {
              inputs?
                Object.keys(inputs).map((inputName, index)=>{
                  return <Fieldset {...{inputArr:{name:inputName,...inputs[inputName]},formID,formsSettings,index,mainInput,fillFormKeys,setFillFormKeys,formStyle}} key={index}/>
                }):
                ''
            }
            {
              parts?
                Object.keys(parts).map((pName,index) => <Parts {...{formID,formsSettings,pName,...parts[pName],fillFormKeys,setFillFormKeys,formStyle}} key={index}/>):
                ''
            }
          </div>:
          ''
      }
      {
        tableInputs?
          Object.keys(tableInputs).map((tblInpID,index)=>{
            return <MrbgTableInput {...{...tableInputs[tblInpID],formID,tblID:tblInpID,formStyle}} key={index}/>
          }):
          ''
      }
      {
        filters?
          <Filter {...{formID,tblID,filters,formsSettings,fillFormKeys,filterMode,setFillFormKeys,setFilterMode,formStyle}}/>:
          ''
      }
      {
        formID.endsWith('__TF')?
          <MrbgTable {...{tblID,columns,rowsCol,pencil,trash,view,unSortable,checkbox,think,multiRow,component,formID,origin,filterMode,formStyle}}/>:
          ''
      }
      {
        !hierarchicalList?
          '':
          hierarchicalListMaxDeep?
            <MrbgHierarchicalList {...{listID:hierarchicalList,mode:'SHD2',hierarchicalListDir,hierarchicalListMaxDeep,setSortList,formStyle}} />:
            <MrbgHierarchicalList {...{listID:hierarchicalList,mode:'SHD2',hierarchicalListDir,hierarchicalListMaxDeep,setSortList,formStyle}} />
      }
      {
        formsSettings?.timer?
          <Timer formID />:
          ''
      }
      {
        formsSettings?
          Object.keys(formsSettings?.hideInp).map((inpName,k)=>{
          return <input type="hidden" name={inpName} value={formsSettings.hideInp[inpName]} key={k}/>
        }):
          ''
      }
      {
        timeLine?
          <MrbgTimeLine {...{id:timeLine}}/>:
          ''
      }
      {
        btn?
          <fieldset className={`${formStyle.MP_fieldset} ${formStyle.parentSubmitBtn} ${formStyle.wideFieldset}`}>
            <button type="submit" value="submit" className={`${formStyle.formBtn} ${formsSettings?.btnCls? formStyle[formsSettings.btnCls]: formStyle[btn.class]}`}>{formsSettings?.btnTxt? formsSettings.btnTxt: btn.label}</button>
          </fieldset>:
          ''
      }
      {
        msg?
          Object.keys(formsSettings.msgTxt).length?
            Object.hasOwn(formsSettings?.msgTxt,'__GM')?
              <div className={`${formStyle.msg} ${formStyle.greenMsg}`}>
                {parse(mrbgTools.toHtml.msg(formsSettings.msgTxt?.__GM,formStyle))}
              </div>:
              <div className={`${formStyle.msg} ${formStyle.redMsg}`}>
                {parse(mrbgTools.toHtml.msg(formsSettings.msgTxt?.__RM,formStyle))}
              </div>:
            <div className={formStyle.msg}></div>:
          ''
      }
      {
        formsSettings?.oldImg && Array.isArray(formsSettings.oldImg) && formsSettings.oldImg.length?
          <div className={formStyle.img}>
              {
                formsSettings.oldImg.map((img,k)=>{
                  return(
                    <div className={formStyle.removedImgFrame} key={k}>
                      <i className={`${formStyle.removeImg} fa-regular fa-close`} onClick={()=>removeOldImg(img)}></i>
                      <img src={`/img/${img}`} />
                    </div>
                  )
                })
              }
            </div>:
          ''
      }
    </form>
  )
}
function FormTitle({formID,tblID,title,popupObj,formStyle}){

  const
    tblKey = tblID? tblID.substring(0,tblID.length-1)+'T': null,
    [tblTitle,setTblTitle] = useState( mrbgStore.getState().mrbgVars[tblKey] ),
    lang = document.documentElement.getAttribute('lang'),
    componentTxt = {
      fa:{
        to: 'تا',
        of: 'از',
        item: 'مورد'
      },
      en:{
        to: 'to',
        of: 'of',
        item: 'items'
      }
    };

  useEffect(()=>{
    const unsubscribe = mrbgStore.subscribe(()=>{
      setTblTitle( mrbgStore.getState().mrbgVars[tblKey] )
    })
    return () =>unsubscribe();
  },[]);

  return (
    <div className={`${formStyle.MP_frameH2} ${formStyle.flexRow}`}>
      <h2>
        {parse(mrbgTools.toHtml.text(title,formStyle))}
        {
          tblTitle?
            <span className={formStyle.resultCount}>{`(${tblTitle.s} ${componentTxt[lang].to} ${tblTitle.l} ${componentTxt[lang].of}  ${tblTitle.f} ${componentTxt[lang].item}.)`}</span>:
            ''
        }
        {
          popupObj?
            <i className={`${formStyle.guideBtn} ${popupObj.icon}`} onClick={()=>mrbgStore.dispatch(setActivePopups({fullPU:popupObj.id}))}></i>:
            ''
        }
      </h2>
      <button type="reset" title="refresh form" className={formStyle.refreshForm} onClick={()=>{document.getElementByDataID(formID).mrbgReset()}}>
        <i className="fa-regular fa-refresh"></i>
      </button>
    </div>
  )
}
function Fieldset({inputArr,formID,formsSettings,index,fillFormKeys,setFillFormKeys,formStyle}){
  return(
    <>
      {
        ( Object.hasOwn(inputArr,'0') && Object.hasOwn(inputArr,'1') )?
          <fieldset {...inputArr[0].fldAttr} className={`${formStyle.MP_fieldset} ${inputArr[0]?.fldAttr?.className?.map(i=>formStyle[i]).join(' ')||''}`} key={index}>
            {
              inputArr[0].legend?
                <legend>{`${parse(mrbgTools.toHtml.text(inputArr[0].legend,formStyle))} :`}</legend>:
                <label> {`${parse(mrbgTools.toHtml.text(inputArr[0].label,formStyle))} :`} </label>
            }
            <FieldType {...{inputArr:inputArr[0],formID,formsSettings,fillFormKeys,setFillFormKeys,formStyle}} key={`${index}-1`}/>
            <FieldType {...{inputArr:inputArr[1],formID,formsSettings,fillFormKeys,setFillFormKeys,formStyle}} key={`${index}-2`}/>
          </fieldset>:
          inputArr.type=='hidden'?
            <FieldType {...{inputArr,formID,formsSettings,fillFormKeys,setFillFormKeys,formStyle}}/>:
            <fieldset {...inputArr.fldAttr} className={`${formStyle.MP_fieldset} ${inputArr.fldAttr?.className?.map(i=>formStyle[i]).join(' ')||''}`} key={index}>
              {
                inputArr.legend?
                  <legend>{parse(mrbgTools.toHtml.text(inputArr.legend,formStyle))} :{inputArr.popupObj? <i className={`${formStyle.guideBtn} ${inputArr.popupObj.icon}`} onClick={()=>mrbgStore.dispatch(setActivePopups({fullPU: inputArr.popupObj.id}))}></i>: ''}</legend>:
                  <label> {parse(mrbgTools.toHtml.text(inputArr.label,formStyle ))} :{inputArr.popupObj? <i className={`${formStyle.guideBtn} ${inputArr.popupObj.icon}`} onClick={()=>mrbgStore.dispatch(setActivePopups({fullPU: inputArr.popupObj.id}))}></i>: ''}</label>
              }
              <FieldType {...{inputArr,formID,formsSettings,fillFormKeys,setFillFormKeys,formStyle}}/>
            </fieldset>
      }
    </>
  )
}
function FieldType({inputArr,formID,formsSettings,fillFormKeys,setFillFormKeys,formStyle}){

  if( Object.hasOwn(inputArr,'string') )
    return inputArr.strFld;

  if( inputArr.type ==='mrbgSelect' )
    return <MrbgSelect {...{...inputArr,formID,fillFormKeys,setFillFormKeys,formStyle}}/>

  else if( inputArr.type == 'mrbgNumberInput' )
    return <MrbgNumberInput {...{...inputArr,formID,formStyle}} />

  else if( inputArr.type == 'mrbgPersianDate' )
    return <MrbgPersianDateTime {...{...inputArr,formID,type:'date',formStyle}} />

  else if( inputArr.type == 'mrbgPersianDateTime' )
    return <MrbgPersianDateTime {...{...inputArr,formID,type:'dateTime',formStyle}} />

  else if( inputArr.type == 'mrbgCheckBox' )
    return <MrbgCheckBox {...{...inputArr,formID,formStyle}} />

  else if( inputArr.type == 'mrbgCheckBoxList' )
    return <MrbgCheckBoxList {...{...inputArr,formID,formStyle}} />

  else if( inputArr.type == 'mrbgRadioInput' )
    return <MrbgRadioInput  {...{...inputArr,formID,formStyle}} />

  else if( inputArr.type == 'captcha' )
    return <MrbgCaptcha {...{...inputArr,formID,formStyle}} />

  else if( ['mrbgImgFile','file'].includes(inputArr.type) )
    return <MrbgImgFile {...{...inputArr,formID,formsSettings,formStyle}} />

  else if( inputArr.type == 'mrbgTE' )
    return <MrbgTextEditor {...{...inputArr,formID,formStyle}} />

  else if( inputArr.type == 'textarea' )
    return <MrbgTextarea {...{...inputArr,formID,formStyle}} />

  else if( inputArr.type == 'mrbgTagInput' )
    return <MrbgTagInput {...{...inputArr,formID,formsSettings,formStyle}} />

  else if( inputArr.type == 'mrbgRangeInput' )
    return <MrbgRangeInput {...{...inputArr,formStyle}} />

  else if( inputArr.type == 'hidden' )
    return <input {...inputArr} value={inputArr?.other?.value} />

  else if( inputArr.type == 'mainInput' )
    return(
      <div data-id="mainInput" className={formStyle.mainInput} onClick={(e) => {
        navigator.clipboard.writeText(e.target.innerText);
        e.target.classList.add(formStyle.copied);
        setTimeout(() => e.target.classList.remove(formStyle.copied), 1000);
      }}>{}</div>
    )

  else if( inputArr.type == 'day&Month' ){
    return(
      <div className={formStyle.dateFrame}>
        <MrbgNumberInput {...{...inputArr,formStyle,name:'day[0]',other:{placeholder:'روز',min:1,max:31}}} />
        <span className={formStyle.dateFrameSlash}>/</span>
        <MrbgNumberInput {...{...inputArr,formStyle,name:'day[1]',other:{placeholder:'ماه',min:1,max:12}}} />
      </div>
    )
  }

  else if( inputArr.type == 'year&month' ){
    return(
      <div className={formStyle.dateFrame}>
        <MrbgNumberInput {...{...inputArr,formStyle,name:'month[0]',other:{placeholder:'ماه',min:1,max:12}}} />
        <span className={formStyle.dateFrameSlash}>/</span>
        <MrbgNumberInput {...{...inputArr,formStyle,name:'month[1]',other:{placeholder:'سال'}}} />
      </div>
    )
  }

  else if( inputArr.type == 'bilPayInfo' )
    return <MrbgBilPayInfo {...{formID,formStyle}} />

  else
    return <MrbgNormalInput {...{...inputArr,formID,formStyle}} />
}
function Parts({formID,formsSettings,pName,title,subTitle,inputs,fillFormKeys,setFillFormKeys,formStyle}){

  const
    [length,setLength] = useState( formsSettings?.partsLen[pName]?.currentR ),
    [myArr,setMyArr] = useState( [...Array(length)] ),
    subTitleNum = [
      'اولین',
      'دومین',
      'سومین',
      'چهارمین',
      'پنجمین',
      'ششمین',
      'هفتمین',
      'هشتمین',
      'نهمین',
      'دهمین',
    ];

  useEffect(()=>{
    setMyArr( [...Array(length)] )
  },[length]);
  useEffect(()=>{
    setLength( formsSettings?.partsLen[pName]?.currentR )
  },[formsSettings]);

  return(
    <ul className={formStyle.mrbgPartList}>
      {
        subTitle?
          <div className={formStyle.partTitleFrame}>
            <h3 className={formStyle.partTitle}>{title}</h3>
            <div>
              <ul className={formStyle.mrbgFP_btn}>
                <li>
                  <i className="fa-solid fa-minus-square" onClick={()=>mrbgStore.dispatch(changePartNum({formID,pName,pLen:Math.max(length-1, 1)}))}></i>
                </li>
                <li>
                  افزایش/کاهش {subTitle}
                </li>
                <li>
                  <i className="fa-solid fa-plus-square" onClick={()=>mrbgStore.dispatch(changePartNum({formID,pName,pLen:length+1}))}></i>
                </li>
              </ul>
            </div>
          </div>:
          <h3 className={formStyle.partTitle}>{title}</h3>
      }
      {
        myArr.map((x, i)=>{
          return (
            <li className={formStyle.mrbgFormPart} key={i}>
              {
                subTitle? <h4>{`${subTitleNum[i]? subTitleNum[i]: i} ${subTitle}`}</h4>: ''
              }
              {
                Object.keys(inputs).map((inputName, index)=>{
                  var name =
                    subTitle?
                      inputs[inputName].name.replace(/([^[]*)/, `$1[${i}]`):
                      inputs[inputName].name;
                  return <Fieldset {...{inputArr:{...inputs[inputName],name},formID,formsSettings,index,fillFormKeys,setFillFormKeys,formStyle}} key={index}/>
                })
              }
            </li>
          )
        })
      }
    </ul>
  )
}
function Filter({formID,tblID,filters,formsSettings,fillFormKeys,filterMode,setFillFormKeys,setFilterMode,formStyle}){

  const
    accordionDiv = useRef(null),
    [acrStyle,setAcrStyle] = useState({}),
    [accordionStatus,setAccordionStatus] = useState('C');

  function openCloseAccordion(){
    if( accordionStatus=='C' ){
      setAcrStyle( {style:{height:window.getComputedStyle(accordionDiv.current.querySelector('div')).getPropertyValue('height')}} );
      setTimeout(()=>{setAccordionStatus('O')},600)
    }
    else{
      setAcrStyle( {style:{height:0}} );
      setAccordionStatus('C')
    }
  }

  return(
    <div className={formStyle.accordion}>
      <div className={formStyle.accordionTitle}>
        <i className={`fa-regular fa-filter ${filterMode? formStyle.filterMode: ''}`} onClick={()=>setFilterMode(!filterMode)}></i>
        <span className={filterMode? formStyle.filterMode: ''}>Filter</span>
        <i className={`fa-regular fa-chevron-circle-${accordionStatus=='O'? 'up': 'down'}`} onClick={()=>openCloseAccordion()}></i>
      </div>
      <div className={`${formStyle.accordionBody}${accordionStatus=='O'? ' '+formStyle.overFlowVisible:''}`} ref={accordionDiv} {...acrStyle}>
        <div>
          <input type="hidden" name="tblID" value={tblID}/>
          {
            Object.keys(filters).map((inputName, index) => {
              return <Fieldset {...{inputArr:filters[inputName],formID,index,formsSettings,fillFormKeys,setFillFormKeys,formStyle}} key={index}/>
            })
          }
          <fieldset className={`${formStyle.MP_fieldset} ${formStyle.parentSubmitBtn} ${formStyle.wideFieldset}`}>
            <button type="submit" value="flt" className={`${formStyle.formBtn} ${formStyle.filterBtn}`}>filter</button>
          </fieldset>
        </div>
      </div>
    </div>
  )
}
function Timer({formID}){

  const
    myTimeout = useRef(),
    [diff,setDiff] = useState(undefined),
    [timeUp,setTimeUp] = useState(mrbgStore.getState().formsSettings[formID].timer);

  function resend(){
    var MD = new FormData(document.getElementByDataID(formID));
    mrbgS2S( null, MD, 'RSS', 'usr', false )
  }

  useEffect(()=>{
    if( diff>0 )
      myTimeout.current = setTimeout(()=>{
        setDiff(diff-1);
      },1000)
  },[diff])
  useEffect(()=>{
    if( myTimeout?.current )
      clearTimeout(myTimeout.current)
    setDiff(timeUp-Math.ceil(new Date().getTime()/1000));
  },[timeUp])
  useEffect(()=>{
    const unsubscribe = mrbgStore.subscribe(()=>{
      setTimeUp( mrbgStore.getState().formsSettings[formID].timer )
    })
    return () =>unsubscribe();
  },[])

  return(
    <div className="mrbgFormTimer">
      {
        diff==undefined?
          '':
          diff?
            `${Math.floor(diff/60).toString().padStart(2,"0")}:${(diff%60).toString().padStart(2,"0")}`:
            <span onClick={()=>resend()}>دوباره بفرست</span>
      }
    </div>
  )
}
export default MrbgFormsCreator;